export default __webpack_public_path__ + "static/media/teckSkills.5d3028c0.jfif";